<script setup lang="ts">
import ExpansionPanel from '@/components/form/ExpansionPanel.vue'
import type { PropType } from 'vue'
import { computed, defineEmits, defineProps } from 'vue'
import type { OptionPanelType } from '@/components/calculation-result/type/type'

const props = defineProps({
  title: { type: String, required: true },
  isActive: { type: Boolean, required: true },
  options: {
    type: Array as PropType<OptionPanelType[]>,
    required: true
  },
  modelValue: { type: [String, Number, Boolean, Array, null], required: true },
  type: { type: String, default: 'radio' }
})

const emit = defineEmits(['update:modelValue'])

const computedModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
</script>

<template>
  <ExpansionPanel :title="title" :is-active="isActive">
    <v-radio-group v-if="type === 'radio'" v-model="computedModel" color="primary" hide-details>
      <template v-for="(option, key) in options" :key="key">
        <v-radio :label="option.label" :value="option.value" />
      </template>
    </v-radio-group>
    <div v-else>
      <template v-for="(option, key) in options" :key="key">
        <v-checkbox
          :label="option.label"
          :value="option.value"
          v-model="computedModel"
          hide-details
        />
      </template>
    </div>
  </ExpansionPanel>
</template>

<style scoped></style>
